import React from "react";
import appRoutes from "../../../../infrastructure/constants/appRoutes";
import urlHelper from "../../../../infrastructure/helpers/common/urlHelper";
import ColumnDefinition from "../../../../infrastructure/types/DataGrid/ColumnDefinition";
import CustomIcon from "../../../Common/BootstrapIcons/Custom/CustomIcon";
import iconTooltip from "../../../Common/BootstrapIcons/Tooltip/IconTooltip";
import Spinner from "../../../Common/Spinner/Spinner";
import { ReactComponent as DownloadIcon } from '../../../Common/BootstrapIcons/download.svg';
import { ReactComponent as EditIcon } from '../../../Common/BootstrapIcons/edit.svg';
import { ReactComponent as HistoryIcon } from '../../../Common/BootstrapIcons/history.svg';
import history from '../../../../infrastructure/helpers/react/history';
import EditableText from "../../../Common/EditableText/EditableText";
import BusinessAnalysisDocument from "../../../../types/businessAnalysis/BusinessAnalysisDocument";

const uniqueName = 'business-analysis-home-grid';

const getColumns = (
    onEditClick: (id: number) => void,
    onDownloadClick: (id: number) => Promise<void>,
    onDocumentRenamed: (document: BusinessAnalysisDocument, newName: string) => void,
    showSpinnerForDownloadId: number,
): ColumnDefinition<BusinessAnalysisDocument>[] => {

    return [
        {
            header: 'Id',
            sortKey: 'Id',
            getContent: x => x.id.toString(),
            width: '100px'
        },
        {
            header: 'Name',
            sortKey: 'Name',
            getContent: x => <EditableText onMouseLeave={(value: string) =>onDocumentRenamed(x, value)}
                value={x.name}
                multiline={false} disabled={false} />,
            className: 'break-all',
            width:'300px'
        },
        {
            header: 'Actions',
            getContent: x =>
                <div className='display-flex align-items-center'>
                    <button className="custom-icon-button" onClick={() => onEditClick(x.id)}>
                        <CustomIcon icon={EditIcon} title={iconTooltip.edit} />
                    </button>
                    <button className="custom-icon-button" onClick={() => history.push(urlHelper.buildUrl(appRoutes.businessAnalysis.changeLog, { name: x.name, id: x.id, redirect: encodeURIComponent(appRoutes.businessAnalysis.home) }))}>
                        <CustomIcon icon={HistoryIcon} title={iconTooltip.changeLog} />
                    </button>
                    <button className="custom-icon-button export-icon" onClick={() => onDownloadClick(x.id)}>
                        {
                            x.id === showSpinnerForDownloadId ? <Spinner /> :
                                <CustomIcon icon={DownloadIcon} title={iconTooltip.download} />
                        }
                    </button>
                </div>,
            className: 'display-flex',
            width: '300px'
        }
    ];
};

export { getColumns, uniqueName };